import theme from '@adsk/alloy-react-theme';

export const containerStyle = {
  display: 'flex',
  'flex-direction': 'row',
};

export const labelStyle = {
  color: theme.colors.adskBlue700,
  textDecoration: 'none',
  '&:hover': {
    color: theme.colors.adskBlue500,
  },
  '&:active': {
    color: theme.colors.adskBlue700,
  },
  cursor: 'pointer',
};
